import type { Item } from '~/shared/api'

export type SalesSourceLabelKey =
  | 'products:salesSourceSite'
  | 'products:salesSourceOzon'
  | 'products:salesSourceWildberries'
  | 'products:salesSourceYandexMarket'
  | 'products:salesSourceOther'

export interface SoldLastMonthSourceItem {
  labelKey: SalesSourceLabelKey
  value: number
}

export const getSalesSources = (
  sources: Item['soldLastMonthSources'],
): SoldLastMonthSourceItem[] => [
  { labelKey: 'products:salesSourceSite', value: sources.site },
  { labelKey: 'products:salesSourceOzon', value: sources.ozon },
  { labelKey: 'products:salesSourceWildberries', value: sources.wildberries },
  {
    labelKey: 'products:salesSourceYandexMarket',
    value: sources['yandex-market'],
  },
  { labelKey: 'products:salesSourceOther', value: sources.other },
]
